import React, { useState } from 'react';
import { bool, shape, string } from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import RuleExceptionModal from '../../containers/Modals/RuleExceptionModal';

import defaultClasses from './ContextMenu.module.css';

const DEFAULT_MODAL_STATES = Object.freeze({
    exceptionViewer: false
});

const ContextMenu = ({ exception, hidden }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [modalStates, setModalStates] = useState({ ...DEFAULT_MODAL_STATES });
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleModalClose() {
        setModalStates({ ...DEFAULT_MODAL_STATES });
        handleClose();
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleViewRuleError() {
        setModalStates({
            ...DEFAULT_MODAL_STATES,
            exceptionViewer: true
        });
        handleClose();
    }

    return (
        <>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={handleViewRuleError}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/ruleErrorIconColor.svg"
                    />
                    View Full Error Message
                </MenuItem>
            </Menu>
            <RuleExceptionModal
                exception={exception}
                onConfirm={handleModalClose}
                onClose={handleModalClose}
                open={modalStates.exceptionViewer}
            />
        </>
    );
};

ContextMenu.defaultProps = {
    hidden: false
};

ContextMenu.propTypes = {
    hidden: bool,
    rule:   shape({
        id: string
    })
};

export default ContextMenu;
